<div class="panel">
        <div class="panel__header">
                <!--Main header-->
                <span class="panel__header__title">{{'Model Search' | translate | async}}</span>
              </div>
    <app-search-container></app-search-container>
   
  </div>
